import { CaptchaDTO } from './../../models/captchaDTO.model';
import { ActivatedRoute, Router, NavigationExtras, ParamMap } from '@angular/router';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';




import { Eleicao } from './../../models/eleicao.model';
import { CanditadosService } from './../../services/canditados.service';
import { Candidato } from './../../models/candidato.model';
import { Cargo } from './../../models/cargo.model';
import { CargoService } from './../../services/cargo.service';
import { ComprovanteVoto } from './../../models/comprovante-participante.model';
import { ComprovanteService } from './../../services/comprovante.service';
import { StorageService } from './../../services/storage.service';
import { LoginParticipante } from '../../models/login-participante.model';
import { Credencias } from 'src/app/models/credencias.model';
import { sha256 } from 'js-sha256';
import jwt_decode from "jwt-decode";


import { MessageService } from 'primeng/api';
//import { RecaptchaLoaderService } from 'ng-recaptcha';
import { HttpClient} from '@angular/common/http';
import { Eleitor } from 'src/app/models/eleitor.model';
import { Comprovante } from 'src/app/models/comprovante.model';
import { LoginService } from 'src/app/services/login.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { StatusEleicao } from 'src/app/models/enums/status-eleicao-enum';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { Utils } from 'src/app/utils/utils';
import { EleitorDTO } from 'src/app/models/eleitorDTO.model';
import { EleitorService } from 'src/app/services/eleitor.service';
import {AprovadorService} from 'src/app/services/aprovador.service'
import { NewEleitorDTO } from 'src/app/models/newEleitorDTO.model';

import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';

//### REFERENCIA DO RECAPTCHA ---- https://github.com/DethAriel/ng-recaptcha#example-preload-api

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  @ViewChild('openModalSenha', {static: false}) openModalSenha;
  @ViewChild('closeModalSenha', {static: false}) closeModalSenha;
  @Input() mensagem: string;

  captchaDTO: CaptchaDTO;

  formGroup: FormGroup;
  formRecuperacaoSenha: FormGroup;
  comprovantes: ComprovanteVoto[] = [];
  cargos: Cargo[] = [];
  cargo?: Cargo;
  candidatos: Candidato[] = [];
  totalVotosPermitidos: number;
  usuario: Eleitor;
  eleicao: Eleicao;
  resultadoValidacaoCaptchaV3: any;
  loginService: LoginService;
  comprovante: Comprovante[];
  dataInicio: Date = new Date();
  sessaoExpirou: boolean
  numTentativasLogin: number = 0;
  fluxoValidacaoCaptcha: Boolean;
  temIntegracao : Boolean = false;
  alterarSenhaUrl: string;
  pk: string;
  pStock: string;
  logoutUrl: string;
  mostrarCaptchaV2: boolean = false;
  mensagemError: string;
  labelAuth1: string;
  labelAuth2: string;
  name: any;
  a: any;
  loadModal: boolean = false;
  encontrouEleicao: boolean = false;
  tokenCaptcha: string;
  tokenCaptchaV3: string;
  tokenCaptchaV2: string;
  tipoCaptcha: string;
  placeHolderLogin: string ='Login';


  /* credencias de acesso */
  creds: Credencias = {
    login: "",
    senha: ""
  }
  //
  eleicaoRota: any;
  role: any;

  idUsuario: any;
  idGestor: any;
  idEleicao: any;
  idAprovador: any;

  constructor(
    protected router: Router,
    public route: ActivatedRoute,
    private frmBuilder: FormBuilder,
    private auth: LoginService,
    protected messageService: MessageService,
    protected eleicaoService: EleicaoService,
    protected eleitorService: EleitorService,
    protected aprovadorService: AprovadorService,
    private  utils: Utils,
    private storage: StorageService,
    private cargoServices: CargoService,
    protected candidatoService: CanditadosService,
    private comprovanteServices: ComprovanteService,
    //private recaptchaLoaderService: RecaptchaLoaderService,
    private http: HttpClient,
    private recaptchaV3Service: ReCaptchaV3Service,
    private spinner: NgxSpinnerService
  ) {

  }

   ngOnInit() {
    let parametrosRota = this.route.snapshot.params;
    let parametrosQuery = this.route.snapshot.queryParams;
    this.eleicaoRota = parametrosRota.rotaEleicao;
    this.role = parametrosQuery.role ? parametrosQuery.role : this.router.url ;
    //this.role = this.router.url;
    if(!parametrosQuery.role) {
    this.eleicaoService.verifyIntegracao(this.eleicaoRota).then((res: any)=>{
      this.temIntegracao = res.temIntegracao;
      this.alterarSenhaUrl = res.alterarSenhaUrl;
      this.logoutUrl = res.logoutUrl;
      this.pk = res.p;
      this.pStock = res.pStock;
      this.placeHolderLogin = res.placeHolderLogin !== null && res.placeHolderLogin.trim() !== ""? res.placeHolderLogin : 'Login' ;
    }).catch(err=>{
      console.log(err)
    });}
  
    this.formGroup = this.frmBuilder.group({
      'login': ['', [Validators.required]],
      'senha': ['', [Validators.required]]
    });

    this.formRecuperacaoSenha = new FormGroup({
      loginEleitor: new FormControl(),
      auth1: new FormControl(),
      auth2: new FormControl(),

    });
    this.formRecuperacaoSenha = this.frmBuilder.group({
      'loginEleitor': ['', [Validators.required, this.utils.noWhitespaceValidator]],
      'auth1': ['', [Validators.required, this.utils.noWhitespaceValidator]],
      'auth2': ['', [Validators.required, this.utils.noWhitespaceValidator]],
    });
    this.formGroup.patchValue(this.creds);
    this.limparSessao();
    sessionStorage.setItem('timeOut', 'ativa');
    this.spinner.hide();
  }

  public timeoutEncerrarSessao() {
    setTimeout(() => {
      sessionStorage.setItem('timeOut', 'expirou');
      this.router.navigate(['/error-sessao']);
    }, 1680000);
  }

  public login() {
    this.spinner.show();
    if (this.role == "/admin") {
      //LOGIN DO ADMIN
      this.auth.authenticateLoginAdmin(this.creds).subscribe((result: any) => {
        this.spinner.show();
        var token = result.token
        //Adiciona o token à sessão e retorna o ID do admin
        sessionStorage.setItem("token", token)
        var decoded = jwt_decode(token);
        sessionStorage.setItem("infoAdmin", JSON.stringify(decoded))
        var infoAdmin = JSON.parse(sessionStorage.getItem("infoAdmin"))
        this.router.navigate(['lista-gestores'], { relativeTo: this.route });
      }, err => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.message , detail: "Verifique suas credenciais e tente novamente." });
        this.formGroup.reset();
      })


    } else if (this.role == "/gestor") {
      // sessionStorage.setItem('eleicaoRota', this.eleicaoRota);
      //LOGIN DO GESTOR
      this.auth.authenticateLoginGestor(this.creds).subscribe((result: any) => {
        var token = result.token
        //Adiciona o token à sessão e retorna o ID do eleitor
        sessionStorage.setItem("token", token)
        var decoded = jwt_decode(token);
        sessionStorage.setItem("infoGestor", JSON.stringify(decoded))
        var infoGestor = JSON.parse(sessionStorage.getItem("infoGestor"));
        this.idGestor = infoGestor.id;
        sessionStorage.setItem("idGestor", this.idGestor)
        this.idEleicao = infoGestor.idEleicao;
        this.router.navigate(['lista-eleicoes'], { relativeTo: this.route });
      }, err => {
        this.spinner.hide();
        this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.message, detail: "Verifique suas credenciais e tente novamente." });
        this.formGroup.reset();
      })
    } else if (this.role == "/assistente") {
      // sessionStorage.setItem('eleicaoRota', this.eleicaoRota);
      //LOGIN DO GESTOR
      this.auth.authenticateLoginAssistente(this.creds).subscribe((result: any) => {
        var token = result.token
        //Adiciona o token à sessão e retorna o ID do eleitor
        sessionStorage.setItem("token", token)
        var decoded = jwt_decode(token);
        sessionStorage.setItem("infoGestor", JSON.stringify(decoded));
        sessionStorage.setItem("infoAssistente", JSON.stringify(decoded))
        var infoGestor = JSON.parse(sessionStorage.getItem("infoGestor"));
        this.idGestor = infoGestor.id;
        sessionStorage.setItem("idGestor", this.idGestor)
        this.idEleicao = infoGestor.idEleicao;
        this.router.navigate(['eleicoes'], { relativeTo: this.route });
      }, err => {
        this.spinner.hide();
        this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.message, detail: "Verifique suas credenciais e tente novamente." });
        this.formGroup.reset();
      })
    } else if (this.role == "aprovador" ) {
      //LOGIN DO APROVADOR
      this.creds.senha = sha256.update(this.creds.senha).hex();
      this.auth.authenticateLoginAprovador(this.creds, this.eleicaoRota).subscribe((result: any) => {
        var token = result.token
        //Adiciona o token à sessão e retorna o ID do aprovador
        sessionStorage.setItem("token", token)
        var decoded = jwt_decode(token);
        sessionStorage.setItem("infoAprovador", JSON.stringify(decoded))
        var infoAprovador = JSON.parse(sessionStorage.getItem("infoAprovador"));
        this.idAprovador = infoAprovador.id;
        sessionStorage.setItem("idAprovador", this.idAprovador)
        sessionStorage.setItem("rotaEleicao", this.eleicaoRota);
        sessionStorage.setItem("role", this.role);
        this.router.navigate(['aprovador/lista-cargos'], { relativeTo: this.route });
      }, err => {
        this.spinner.hide();
        this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.error, detail: err.error.message });
        this.formGroup.reset();
      })
    } else {

      if (this.temIntegracao == true) {
        if (this.pStock) {
          var md5 = require('md5')
          this.creds.senha = md5(this.creds.senha);
        } else if(this.pk!=null) {
          this.creds.senha = this.utils.enc(this.creds.senha, this.pk);
          //remover linha abaixo após fabasa
          this.creds.login = this.creds.login.replace(/[.-]/g, '');
        }else{
          this.creds.senha = sha256.update(this.creds.senha).hex();
        }
      } else {
        this.creds.senha = sha256.update(this.creds.senha).hex()
      }

      this.auth.authenticateLoginEleitor(this.creds, this.eleicaoRota).subscribe((result: any) => {
        this.spinner.show();
        var token = result.token;
        this.eleicao = result.eleicao;
        this.eleicao.eleicaoEncerrada = result.eleicaoEncerrada;
        //Adiciona o token à sessão e retorna o ID do eleitor
        sessionStorage.setItem("token", token)
        var decoded = jwt_decode(token);
        sessionStorage.setItem("infoEleitor", JSON.stringify(decoded))
        sessionStorage.setItem("rotaEleicao",result.eleicao.rotaEleicao)
        var infoEleitor = JSON.parse(sessionStorage.getItem("infoEleitor"))
        this.idUsuario = infoEleitor.id;
        this.idEleicao = infoEleitor.idEleicao;
        this.getComprovantePorIdLogin(this.idUsuario, this.eleicao);
      }, err => {
        this.spinner.hide();
        let msg = err.error.message;
        if(err.error.message.includes('Eleição não encontrada') ||
           err.error.message.includes('Acesso momentaneamente suspenso') ||
           err.error.error.includes('Tentativa de Múltiplos Acessos')){
          this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.message});
        }else{
            this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.error, detail: err.error.message });
        }
        this.formGroup.reset();
      })
    }
  }

  async onSubmit(value) {
    if (environment.production) {
      // Obtem token captcha apenas em produção
      this.recaptchaV3Service.execute('importantAction')
        .subscribe(async (token) => {
          await this.validarTokenCaptcha(token)
          if (this.fluxoValidacaoCaptcha == true) {
            // Validação de credenciais para o login
            this.mostrarCaptchaV2 = false
            this.creds = value as Credencias;
            this.login();
          }
        })
    } else {
      // Em outros ambientes, apenas faz login normalmente
      this.creds = value as Credencias;
      this.login();
    }
  }

  public async validarTokenCaptcha(token: any) {
    this.tokenCaptchaV3 = token
    if(this.tokenCaptchaV3)
    {
      if(this.mostrarCaptchaV2 == true){
        this.tipoCaptcha = "V2"
        this.tokenCaptcha = this.tokenCaptchaV2
      }else{
        this.tipoCaptcha = "V3"
        this.tokenCaptcha = token
      }
      await this.auth.validarTokenCaptchaService(this.tokenCaptcha, this.tipoCaptcha).then((resultadoValidacaoCaptcha: any)=>{
        if(resultadoValidacaoCaptcha.success == true)
        {
          if(this.mostrarCaptchaV2 == true)
          {
            this.fluxoValidacaoCaptcha = true
            return true
          }
          // score ou possibilidade de movimentação suspeita for menor 0.9 (quanto menor mais chances de ser um robo)
          if (resultadoValidacaoCaptcha.score <= 0.5)
          {
            //obriga usuario a realizar o desafio de imagens do captcha V2
            this.mostrarCaptchaV2 = true
            this.fluxoValidacaoCaptcha = false
            return false
          }else{
            this.fluxoValidacaoCaptcha = true
            return true
          }
        }
      });
    }
    else{
      return false
    }
  }

  public getComprovantePorIdLogin(idUsuario: any, eleicao: Eleicao) {
    var token = sessionStorage.getItem("token")
    this.comprovanteServices.getComprovanteVotoPorIdEleitor(idUsuario, token).then((result: any) => {
      this.comprovante = result;
      if (eleicao.eleicaoEncerrada) {
        //leva ao comprovante e resultado da eleição
        this.spinner.hide();
        this.router.navigate(['eleitor/comprovante'], {relativeTo: this.route});
      }
      else{
        this.comprovanteServices.validaCandidatosAVotar(this.idEleicao, this.comprovante, token).then((res: []) => {
          this.spinner.hide();
          if (res.length > 0) {
            this.router.navigate(['eleitor/termo'], {relativeTo: this.route});
          } else {
            this.router.navigate(['eleitor/comprovante'], {relativeTo: this.route});
          }
        }).catch(err => {
          this.router.navigate(['/error-sessao']);
        });
      }
    })
  }

  public getCargoPorId(id: number) {
    this.cargoServices.getById(id).subscribe(result => {
      this.cargo = result;
    }, error => { })
  }

  public limparSessao() {
    sessionStorage.clear();
  }

  public okFalhaAutenticaoLogin() {
    this.messageService.clear('c');
  }

  public atualizamostrarCaptchaV2(show: boolean) {
    this.mostrarCaptchaV2
  }

  public msgRedirecionamentoParaMeuFuturo() {
    alert(`Faça a alteração de senha na Área do Participante do seu plano no site da entidade.`)
  }

  resolved(captchaResponse: string) {
    this.tokenCaptchaV2 = captchaResponse
  }

  public async resetPassword() {
    this.loadModal = true;
    //Retorna o role do usuário para saber qual fluxo de reset de senha ser aplicado
    //Apenas gestores e participantes podem usar esse reset (o admin manipula via database)
    if (this.role == '/gestor' || this.role == '/assistente') {
      this.mensagem = "Caro gestor, para alterar a sua senha de acesso, é necessário abrir um chamado clicando no botão abaixo."
      this.openModalSenha.nativeElement.click();
    } else {
      //aqui acessa o service de login do participante
      if(this.temIntegracao == true){
        this.encontrouEleicao = true;
        this.mensagem = "Caro eleitor, para alterar a sua senha de acesso, é necessário acessar o site da entidade."
        this.openModalSenha.nativeElement.click();
        await this.openWindowLogout(this.logoutUrl);

      }else{
        this.encontrouEleicao = true;
        this.mensagem = "Caro eleitor(a), ao clicar no botão abaixo você receberá um mensagem em seu e-mail com orientações para realizar a redefinição de senha.\nSó precisamos confirmar que é você. Por favor, preencha as informações abaixo:";
        if(await this.buscarLabelAutenticacao()){
          this.openModalSenha.nativeElement.click();
        }
      }
    }
    this.loadModal = false;
  }

  async buscarLabelAutenticacao(){
    let result = false;
    await this.eleicaoService.getEleicaoByRota(this.eleicaoRota).then((res: any)=>{
      this.labelAuth1 = res.labelAuth1 != null ? res.labelAuth1 : "Informação Autenticação 1";
      this.labelAuth2 = res.labelAuth2 != null ? res.labelAuth2 : "Informação Autenticação 2";
      this.idEleicao = res.id;
      result = true;
      }).catch(err=>{
      this.messageService.add({ key: 'toast', severity: 'error', summary: "Atenção", detail: "Funcionalidade indisponível no momento." });
      console.log(err)
    });
    return result;
  }

  public async redicionarSenhaIntegracao() {
    //this.openWindowLogout(this.logoutUrl);
    this.openNewWindow(this.alterarSenhaUrl);
    }

    public async openWindowLogout(url){
      if(url != null){
        var newWindow = window.open(url, 'Hidden Window', 'width=10,height=10');
        setTimeout(function() {
          newWindow.close();
      },200);
      }
    }
    public async openNewWindow(url){
      window.open(url,'_blank');
    }


  public abrirChamado() {
    window.open('https://servicos.stockinfo.com.br/', '_blank');
  }

  public async alterarSenhaEleitor(){
    if(this.formRecuperacaoSenha.valid){
      let e = new NewEleitorDTO();
      e.login = this.formRecuperacaoSenha.get('loginEleitor').value
      e.auth1 = this.formRecuperacaoSenha.get('auth1').value
      e.auth2 = this.formRecuperacaoSenha.get('auth2').value
      let hashInfo = { // Omitindo dados pessoais para trnasitar na request (LGPD)
        param1: sha256.update(e.login).hex(),
        param2: sha256.update(e.auth1).hex(),
        param3: sha256.update(e.auth2).hex(),
        param4: this.idEleicao
      };
      let params = (JSON.stringify(hashInfo));
      this.closeModalSenha.nativeElement.click();
      this.encontrouEleicao = false;
      if(this.role =='aprovador'){
        this.aprovadorService.recuperacaoSenhaAprovadorEmail(params).then( () => {
          this.messageService.add({ key: 'toast', severity: 'info', summary: "Atenção!", detail: "Email enviado com sucesso! Verifique os próximos passos para redefinir sua senha."});
          this.formRecuperacaoSenha.reset();
        }, (error) => {
          this.messageService.add({ key: 'toast', severity: 'error', summary: "Atenção!", detail: error });
        });
      }else{
        this.eleicaoService.recuperacaoSenhaEleitorEmail(params).then( () => {
          this.messageService.add({ key: 'toast', severity: 'info', summary: "Atenção!", detail: "Email enviado com sucesso! Verifique os próximos passos para redefinir sua senha."});
          this.formRecuperacaoSenha.reset();
        }, (error) => {
          this.messageService.add({ key: 'toast', severity: 'error', summary: "Atenção!", detail: error });
        });
      }
    }else{
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: "Preencha todos os campos do formulário!"  });
    }
  }
}
